"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeComponent = exports.PlainLayout = exports.DocsSideBarAppLayout = exports.SideBarAppLayout = exports.DocsFooter = exports.HomeFooter = exports.HomeHeader = void 0;
const react_1 = __importStar(require("react"));
const useAuth_1 = require("@authlance/core/lib/browser/hooks/useAuth");
const react_query_1 = require("@tanstack/react-query");
const react_query_devtools_1 = require("@tanstack/react-query-devtools");
const query_client_1 = require("@authlance/core/lib/browser/query-client");
const sidebar_1 = require("@authlance/ui/lib/browser/components/sidebar");
const react_router_dom_1 = require("react-router-dom");
const toaster_1 = require("@authlance/ui/lib/browser/components/toaster");
const user_routes_provider_1 = __importDefault(require("@authlance/core/lib/browser/hooks/user-routes-provider"));
const button_1 = require("@authlance/ui/lib/browser/components/button");
const store_1 = require("@authlance/core/lib/browser/store");
const RenderIf_1 = __importDefault(require("@authlance/core/lib/browser/components/RenderIf"));
const lucide_react_1 = require("lucide-react");
const react_router_hash_link_1 = require("react-router-hash-link");
const dropdown_menu_1 = require("@authlance/ui/lib/browser/components/dropdown-menu");
const avatar_1 = require("@authlance/ui/lib/browser/components/avatar");
const useBrand_1 = require("@authlance/core/lib/browser/hooks/useBrand");
const path_to_regexp_1 = require("path-to-regexp");
const useSidebarSecondaryItemProvider_1 = __importDefault(require("@authlance/license-layout/lib/browser/hooks/useSidebarSecondaryItemProvider"));
const useDashboardContent_1 = __importDefault(require("@authlance/license-layout/lib/browser/hooks/useDashboardContent"));
const useMainActionProvider_1 = __importDefault(require("@authlance/license-layout/lib/browser/hooks/useMainActionProvider"));
const authenticated_sidebar_1 = require("@authlance/license-layout/lib/browser/components/authenticated-sidebar");
const docs_sidebar_1 = require("@authlance/license-layout/lib/browser/components/docs-sidebar");
const useSideBarContext_1 = require("@authlance/license-layout/lib/browser/hooks/useSideBarContext");
const useGroupContext_1 = __importDefault(require("../hooks/useGroupContext"));
const group_slice_1 = require("@authlance/core/lib/browser/store/slices/group-slice");
const DASHBOARD_TITLE = 'Dashboard';
// Locally retype the hash link so we rely on the app's React version.
const HashLink = react_router_hash_link_1.HashLink;
const HOME_NAV_LINKS = [
    { label: 'Overview', hash: '#overview' },
    { label: 'Problem', hash: '#problem' },
    { label: 'Solution', hash: '#solution' },
    { label: 'Licensing', hash: '#licenses' },
    { label: 'Platform', hash: '#platform' },
    { label: 'License Operator', hash: '#license-operator' },
    // { label: 'Deployment', hash: '#deployment' },
];
function useSmartBack() {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const location = (0, react_router_dom_1.useLocation)();
    const historyRef = (0, react_1.useRef)([]);
    // Track visited locations
    (0, react_1.useEffect)(() => {
        const currentPath = location.pathname + location.search;
        const lastPath = historyRef.current[historyRef.current.length - 1];
        if (currentPath !== lastPath) {
            historyRef.current.push(currentPath);
        }
    }, [location]);
    const stripParams = (url) => {
        try {
            const base = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
            const u = new URL(url, base);
            return u.pathname;
        }
        catch (_a) {
            // Fallback if it's a relative path
            return url.split('?')[0].split('#')[0];
        }
    };
    const goBackToDifferent = () => {
        const paths = historyRef.current;
        const current = paths.pop();
        let prev = paths.pop();
        const currentBase = current ? stripParams(current) : null;
        while (prev && currentBase && stripParams(prev) === currentBase) {
            prev = paths.pop();
        }
        if (prev) {
            navigate(prev);
        }
        else {
            navigate('/');
        }
    };
    return goBackToDifferent;
}
const HomeHeader = ({}) => {
    const location = (0, react_router_dom_1.useLocation)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { user, logoutUrl, clearSession, forceChallenge, targetGroup, isSysAdmin } = (0, react_1.useContext)(useAuth_1.SessionContext);
    const authContext = (0, react_1.useContext)(useAuth_1.SessionContext);
    const isRoot = (0, react_1.useMemo)(() => location.pathname === '/', [location.pathname]);
    const brandLogo = (0, useBrand_1.useBrandLogo)();
    const sidebarSecondaryItemProvider = (0, useSidebarSecondaryItemProvider_1.default)();
    const { state } = (0, useSideBarContext_1.useSideBarContext)();
    const avatarFallback = (0, react_1.useMemo)(() => {
        if (user && user.firstName && user.lastName && user.firstName.length > 0 && user.lastName.length > 0) {
            return user.firstName.charAt(0) + user.lastName.charAt(0);
        }
        if (user && user.firstName && user.firstName.length >= 2) {
            return user.firstName.substring(0, 2);
        }
        return 'NA';
    }, [user]);
    const isDocsPage = (0, react_1.useMemo)(() => {
        return location.pathname.startsWith('/docs');
    }, [location.pathname]);
    const logoutAction = (0, react_1.useCallback)(async () => {
        try {
            if (logoutUrl && typeof window !== 'undefined') {
                clearSession();
                window.location.href = logoutUrl;
            }
        }
        catch (error) {
            console.error(error);
        }
    }, [clearSession, logoutUrl]);
    const loginAction = (0, react_1.useCallback)(async () => {
        forceChallenge();
    }, [forceChallenge]);
    const viewProfile = (0, react_1.useCallback)(() => {
        navigate('/user/profile');
    }, [navigate]);
    const secondaryItems = (0, react_1.useMemo)(() => {
        if (!authContext || !sidebarSecondaryItemProvider) {
            return [];
        }
        return sidebarSecondaryItemProvider.getSecondaryItems(authContext);
    }, [sidebarSecondaryItemProvider, authContext]);
    const manageLicensesPath = (0, react_1.useMemo)(() => {
        if (targetGroup && targetGroup.trim().length > 0) {
            return '/licenses/group';
        }
        return '/pricing';
    }, [targetGroup]);
    return (react_1.default.createElement("header", { className: "sticky top-0 z-40 border-b backdrop-blur bg-background/75 border-border" },
        react_1.default.createElement("div", { className: "flex items-center justify-between h-16 px-4 mx-auto max-w-7xl sm:px-6 lg:px-8" },
            react_1.default.createElement("div", { className: "flex gap-2" },
                react_1.default.createElement("div", { className: "flex items-center gap-2" },
                    react_1.default.createElement(RenderIf_1.default, { isTrue: Boolean(user && isSysAdmin && targetGroup && state === 'expanded') },
                        react_1.default.createElement(docs_sidebar_1.HiddenSidebarTrigger, null))),
                react_1.default.createElement(RenderIf_1.default, { isTrue: Boolean(!isDocsPage && !(user && targetGroup && isSysAdmin)) },
                    react_1.default.createElement(react_router_dom_1.Link, { to: "/", className: "flex items-center gap-2" },
                        react_1.default.createElement("div", { className: "h-8" },
                            react_1.default.createElement("img", { height: 24, src: brandLogo, className: "h-8", alt: "Authlance" })),
                        react_1.default.createElement("span", { className: "font-semibold sr-only" }, "Authlance")))),
            react_1.default.createElement(RenderIf_1.default, { isTrue: isRoot },
                react_1.default.createElement("nav", { className: "items-center hidden gap-6 text-sm md:flex" },
                    HOME_NAV_LINKS.map((link) => (react_1.default.createElement(HashLink, { key: link.hash, smooth: true, to: { hash: link.hash }, className: "font-medium text-muted-foreground transition-colors hover:text-primary" }, link.label))),
                    react_1.default.createElement(react_router_dom_1.Link, { to: '/docs', className: "font-medium text-muted-foreground transition-colors hover:text-primary" }, "Docs"),
                    react_1.default.createElement(react_router_dom_1.Link, { to: '/pricing', className: "font-medium text-muted-foreground transition-colors hover:text-primary" }, "Pricing"))),
            react_1.default.createElement(RenderIf_1.default, { isTrue: !isRoot },
                react_1.default.createElement("nav", { className: "items-center hidden gap-6 text-sm md:flex" },
                    HOME_NAV_LINKS.map((link) => (react_1.default.createElement(HashLink, { key: link.hash, smooth: true, to: { pathname: '/', hash: link.hash }, className: "font-medium text-muted-foreground transition-colors hover:text-primary" }, link.label))),
                    react_1.default.createElement(react_router_dom_1.Link, { to: '/docs', className: "font-medium text-muted-foreground transition-colors hover:text-primary" }, "Docs"),
                    react_1.default.createElement(react_router_dom_1.Link, { to: '/pricing', className: "font-medium text-muted-foreground transition-colors hover:text-primary" }, "Pricing"))),
            react_1.default.createElement("div", { className: "flex items-center gap-2" },
                react_1.default.createElement(RenderIf_1.default, { isTrue: Boolean(!user) },
                    react_1.default.createElement(button_1.Button, { variant: "link", className: "px-3 py-2 text-sm rounded-xl hover:underline", onClick: (e) => {
                            e.preventDefault();
                            loginAction();
                        } }, "Sign in")),
                react_1.default.createElement(RenderIf_1.default, { isTrue: Boolean(user && targetGroup) },
                    react_1.default.createElement("div", { className: "flex items-center gap-2" },
                        react_1.default.createElement(button_1.Button, { onClick: () => navigate(manageLicensesPath) }, "My Licenses"),
                        react_1.default.createElement(dropdown_menu_1.DropdownMenu, null,
                            react_1.default.createElement(dropdown_menu_1.DropdownMenuTrigger, { asChild: true },
                                react_1.default.createElement(button_1.Button, { variant: "ghost", className: "flex items-center gap-2 px-2" },
                                    react_1.default.createElement(avatar_1.Avatar, { className: "w-8 h-8 rounded-lg" },
                                        react_1.default.createElement(avatar_1.AvatarImage, { src: user === null || user === void 0 ? void 0 : user.avatar, alt: user === null || user === void 0 ? void 0 : user.firstName }),
                                        react_1.default.createElement(avatar_1.AvatarFallback, { className: "rounded-lg" }, avatarFallback)),
                                    react_1.default.createElement(lucide_react_1.ChevronDown, { className: "w-4 h-4" }))),
                            react_1.default.createElement(dropdown_menu_1.DropdownMenuContent, { align: "end", className: "w-56" },
                                secondaryItems.map((item, index) => (react_1.default.createElement(dropdown_menu_1.DropdownMenuItem, { key: `plain-layout-footer-item-${item.id}-${index}`, onClick: item.action },
                                    react_1.default.createElement("span", null, item.label)))),
                                react_1.default.createElement(dropdown_menu_1.DropdownMenuItem, { onClick: viewProfile },
                                    react_1.default.createElement("span", null, "Account Profile")),
                                react_1.default.createElement(dropdown_menu_1.DropdownMenuItem, { onClick: logoutAction },
                                    react_1.default.createElement("span", null, "Logout"))))))))));
};
exports.HomeHeader = HomeHeader;
const HomeFooter = ({}) => {
    const { user, forceChallenge, targetGroup } = (0, react_1.useContext)(useAuth_1.SessionContext);
    const brandLogo = (0, useBrand_1.useBrandLogo)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const manageLicensesPath = (0, react_1.useMemo)(() => {
        if (targetGroup && targetGroup.trim().length > 0) {
            return '/licenses/group';
        }
        return '/licenses/group';
    }, [targetGroup]);
    const loginAction = (0, react_1.useCallback)(async () => {
        forceChallenge();
    }, [forceChallenge]);
    (0, react_1.useEffect)(() => {
        if (!document) {
            return;
        }
        const yearEl = document.getElementById('year');
        if (!yearEl) {
            return;
        }
        yearEl.textContent = new Date().getFullYear().toString();
    }, []);
    return (react_1.default.createElement("footer", { className: "py-12" },
        react_1.default.createElement("div", { className: "px-4 mx-auto max-w-7xl sm:px-6 lg:px-8 border-t border-border py-12" },
            react_1.default.createElement("div", { className: "grid gap-10 md:grid-cols-2" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: "flex items-center gap-2" },
                        react_1.default.createElement("img", { src: brandLogo, alt: "Authlance logo", className: "h-8" }),
                        react_1.default.createElement("span", { className: "sr-only" }, "Authlance")),
                    react_1.default.createElement("p", { className: "mt-3 text-sm text-muted-foreground" }, "Authentication and licensing for founders who want to ship fast."),
                    react_1.default.createElement("p", { className: "mt-3 text-sm text-muted-foreground" }, "Skip auth, roles, billing, and license infrastructure \u2014 keep everything self-hosted and extensible.")),
                react_1.default.createElement("div", { className: "grid gap-8 sm:grid-cols-2" },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("h3", { className: "font-semibold" }, "Explore"),
                        react_1.default.createElement("ul", { className: "mt-3 space-y-2 text-sm text-muted-foreground" }, HOME_NAV_LINKS.map((link) => (react_1.default.createElement("li", { key: `home-footer-link-${link.hash}` },
                            react_1.default.createElement(HashLink, { smooth: true, to: { hash: link.hash }, className: "hover:underline" }, link.label)))))),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(RenderIf_1.default, { isTrue: Boolean(user) },
                            react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("h3", { className: "font-semibold" }, "Take action"),
                                react_1.default.createElement("p", { className: "mt-3 text-sm text-muted-foreground" }, "Issue trials, refresh paid plans, and download signed artifacts for your operators."),
                                react_1.default.createElement("div", { className: "mt-3 flex flex-col gap-2" },
                                    react_1.default.createElement(button_1.Button, { onClick: () => navigate(manageLicensesPath), className: "mt-3 inline-flex items-center gap-2" },
                                        react_1.default.createElement(lucide_react_1.ArrowRight, { className: "h-4 w-4" }),
                                        " Manage licenses"),
                                    react_1.default.createElement(button_1.Button, { variant: "outline", asChild: true },
                                        react_1.default.createElement(react_router_dom_1.Link, { to: "/docs" }, "Read docs"))))),
                        react_1.default.createElement(RenderIf_1.default, { isTrue: Boolean(!user) },
                            react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("h3", { className: "font-semibold" }, "Get started"),
                                react_1.default.createElement("p", { className: "mt-3 text-sm text-muted-foreground" }, "Deploy Authlance on your infrastructure with our docs and pricing guides."),
                                react_1.default.createElement("div", { className: "mt-3 flex flex-col gap-2" },
                                    react_1.default.createElement(button_1.Button, { asChild: true },
                                        react_1.default.createElement(react_router_dom_1.Link, { to: "/pricing" }, "View pricing")),
                                    react_1.default.createElement(button_1.Button, { variant: "outline", asChild: true },
                                        react_1.default.createElement(react_router_dom_1.Link, { to: "/docs" }, "Read docs")),
                                    react_1.default.createElement(button_1.Button, { variant: "link", onClick: (e) => {
                                            e.preventDefault();
                                            loginAction();
                                        }, className: "h-auto p-0 m-0 font-normal text-muted-foreground" }, "Sign in"))))))),
            react_1.default.createElement("div", { className: "flex items-center justify-between pt-6 mt-10 text-xs border-t border-border text-muted-foreground -px-4" },
                react_1.default.createElement("p", null,
                    "\u00A9 ",
                    react_1.default.createElement("span", { id: "year" }),
                    " Authlance"),
                react_1.default.createElement(react_router_dom_1.Link, { to: "/terms-of-service", className: "hover:underline" }, "Terms of Service")))));
};
exports.HomeFooter = HomeFooter;
const DocsFooter = ({}) => {
    const { user, forceChallenge, targetGroup } = (0, react_1.useContext)(useAuth_1.SessionContext);
    const brandLogo = (0, useBrand_1.useBrandLogo)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const manageLicensesPath = (0, react_1.useMemo)(() => {
        if (targetGroup && targetGroup.trim().length > 0) {
            return '/licenses/group';
        }
        return '/licenses/group';
    }, [targetGroup]);
    const loginAction = (0, react_1.useCallback)(async () => {
        forceChallenge();
    }, [forceChallenge]);
    (0, react_1.useEffect)(() => {
        if (!document) {
            return;
        }
        const yearEl = document.getElementById('year');
        if (!yearEl) {
            return;
        }
        yearEl.textContent = new Date().getFullYear().toString();
    }, []);
    return (react_1.default.createElement("footer", { className: "py-4" },
        react_1.default.createElement("div", { className: "mx-auto max-w-7xl sm:px-6 lg:px-8 border-t border-border" },
            react_1.default.createElement("div", { className: "grid gap-10 md:grid-cols-2 py-4" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: "flex items-center gap-2" },
                        react_1.default.createElement("img", { src: brandLogo, alt: "Authlance logo", className: "h-8" }),
                        react_1.default.createElement("span", { className: "sr-only" }, "Authlance")),
                    react_1.default.createElement("p", { className: "mt-3 text-sm text-muted-foreground" }, "Authentication and licensing for founders who want to ship fast."),
                    react_1.default.createElement("p", { className: "mt-3 text-sm text-muted-foreground" }, "Skip auth, roles, billing, and license infrastructure \u2014 keep everything self-hosted and extensible.")),
                react_1.default.createElement("div", { className: "grid gap-8 sm:grid-cols-2" },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("h3", { className: "font-semibold" }, "Explore"),
                        react_1.default.createElement("ul", { className: "mt-3 space-y-2 text-sm text-muted-foreground" }, HOME_NAV_LINKS.map((link) => (react_1.default.createElement("li", { key: `home-footer-link-${link.hash}` },
                            react_1.default.createElement(HashLink, { smooth: true, to: { hash: link.hash }, className: "hover:underline" }, link.label)))))),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(RenderIf_1.default, { isTrue: Boolean(user) },
                            react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("h3", { className: "font-semibold" }, "Take action"),
                                react_1.default.createElement("p", { className: "mt-3 text-sm text-muted-foreground" }, "Issue trials, refresh paid plans, and download signed artifacts for your operators."),
                                react_1.default.createElement(button_1.Button, { onClick: () => navigate(manageLicensesPath), className: "mt-3 inline-flex items-center gap-2" },
                                    react_1.default.createElement(lucide_react_1.ArrowRight, { className: "h-4 w-4" }),
                                    " Manage licenses"))),
                        react_1.default.createElement(RenderIf_1.default, { isTrue: Boolean(!user) },
                            react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement("h3", { className: "font-semibold" }, "Get started"),
                                react_1.default.createElement("p", { className: "mt-3 text-sm text-muted-foreground" }, "Deploy Authlance on your infrastructure with our docs and pricing guides."),
                                react_1.default.createElement("div", { className: "mt-3 flex flex-col gap-2" },
                                    react_1.default.createElement(button_1.Button, { asChild: true },
                                        react_1.default.createElement(react_router_dom_1.Link, { to: "/pricing" }, "View pricing")),
                                    react_1.default.createElement(button_1.Button, { variant: "outline", asChild: true },
                                        react_1.default.createElement(react_router_dom_1.Link, { to: "/docs" }, "Read docs")),
                                    react_1.default.createElement(button_1.Button, { variant: "link", onClick: (e) => {
                                            e.preventDefault();
                                            loginAction();
                                        }, className: "h-auto p-0 m-0 font-normal text-muted-foreground" }, "Sign in"))))))),
            react_1.default.createElement("div", { className: "flex items-center justify-between pt-6 mt-10 text-xs border-t border-border text-muted-foreground" },
                react_1.default.createElement("p", null,
                    "\u00A9 ",
                    react_1.default.createElement("span", { id: "year" }),
                    " Authlance"),
                react_1.default.createElement(react_router_dom_1.Link, { to: "/terms-of-service", className: "hover:underline" }, "Terms of Service")))));
};
exports.DocsFooter = DocsFooter;
const SideBarAppLayout = ({}) => {
    const location = (0, react_router_dom_1.useLocation)();
    const dashboardContentProvider = (0, useDashboardContent_1.default)();
    const mainActionsProvider = (0, useMainActionProvider_1.default)();
    const { pathProvider, user, identityUser, clearSession, logoutUrl, targetGroup, isSysAdmin } = (0, react_1.useContext)(useAuth_1.SessionContext);
    const { userId } = (0, react_router_dom_1.useParams)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const authContext = (0, react_1.useContext)(useAuth_1.SessionContext);
    const routeProvider = (0, user_routes_provider_1.default)();
    const isRoot = (0, react_1.useMemo)(() => location.pathname === '/', [location.pathname]);
    const refreshTick = (0, store_1.useAppSelector)((state) => state.groupContext.refreshTick);
    const goBack = useSmartBack();
    const sidebarSecondaryItemProvider = (0, useSidebarSecondaryItemProvider_1.default)();
    const { state } = (0, useSideBarContext_1.useSideBarContext)();
    const avatarFallback = (0, react_1.useMemo)(() => {
        if (user && user.firstName && user.lastName && user.firstName.length > 0 && user.lastName.length > 0) {
            return user.firstName.charAt(0) + user.lastName.charAt(0);
        }
        if (user && user.firstName && user.firstName.length >= 2) {
            return user.firstName.substring(0, 2);
        }
        return 'NA';
    }, [user]);
    const getTitle = (0, react_1.useCallback)(() => {
        if (isRoot) {
            return '';
        }
        if (!pathProvider) {
            return DASHBOARD_TITLE;
        }
        const currentPath = pathProvider.getCurrentPath();
        const currentRoute = routeProvider.getRoute(currentPath);
        if (!currentRoute) {
            return DASHBOARD_TITLE;
        }
        if (currentRoute.nameProvider) {
            return currentRoute.nameProvider(authContext);
        }
        return currentRoute.name;
    }, [pathProvider, routeProvider, refreshTick, identityUser, user, authContext, isRoot]);
    const canGoBack = (0, react_1.useCallback)(() => {
        if (!pathProvider) {
            return false;
        }
        const currentPath = pathProvider.getCurrentPath();
        const currentRoute = routeProvider.getRoute(currentPath);
        if (!currentRoute) {
            return false;
        }
        return currentRoute.canGoBack || false;
    }, [pathProvider, routeProvider, user, userId]);
    const getCurrentPath = (0, react_1.useCallback)(() => {
        if (!pathProvider) {
            return '';
        }
        return pathProvider.getCurrentPath();
    }, [pathProvider, routeProvider]);
    const currentRoute = (0, react_1.useMemo)(() => {
        if (!pathProvider) {
            return undefined;
        }
        const currentPath = pathProvider.getCurrentPath();
        if (!currentPath) {
            return undefined;
        }
        const currentRoute = routeProvider.getRoute(currentPath);
        if (!currentRoute) {
            return undefined;
        }
        return currentRoute;
    }, [pathProvider, routeProvider]);
    const manageLicensesPath = (0, react_1.useMemo)(() => {
        if (targetGroup && targetGroup.trim().length > 0) {
            return '/licenses/group';
        }
        return '/licenses/group';
    }, [targetGroup]);
    const logoutAction = (0, react_1.useCallback)(async () => {
        try {
            if (logoutUrl && typeof window !== 'undefined') {
                clearSession();
                window.location.href = logoutUrl;
            }
        }
        catch (error) {
            console.error(error);
        }
    }, [clearSession, logoutUrl]);
    const secondaryItems = (0, react_1.useMemo)(() => {
        if (!authContext || !sidebarSecondaryItemProvider) {
            return [];
        }
        return sidebarSecondaryItemProvider.getSecondaryItems(authContext);
    }, [sidebarSecondaryItemProvider, authContext]);
    const viewProfile = (0, react_1.useCallback)(() => {
        navigate('/user/profile');
    }, [navigate]);
    return (react_1.default.createElement(sidebar_1.SidebarProvider, null,
        react_1.default.createElement(authenticated_sidebar_1.AppSidebar, null),
        react_1.default.createElement(sidebar_1.SidebarInset, null,
            react_1.default.createElement(RenderIf_1.default, { isTrue: Boolean(isRoot || !isSysAdmin) },
                react_1.default.createElement(exports.HomeHeader, null)),
            react_1.default.createElement(RenderIf_1.default, { isTrue: Boolean(!isRoot) },
                react_1.default.createElement("header", { className: "bg-background/40 flex shrink-0 items-center justify-between px-4 transition-[width,height] h-[--header-height] md:peer-data-[state=collapsed]:h-[calc(var(--header-height)-4px)] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12 border-b border-border backdrop-blur-md sticky z-50 top-0 md:rounded-tl-xl md:rounded-tr-xl" },
                    react_1.default.createElement("div", { className: "flex items-center gap-2" },
                        react_1.default.createElement(RenderIf_1.default, { isTrue: state === 'expanded' },
                            react_1.default.createElement(docs_sidebar_1.HiddenSidebarTrigger, null))),
                    react_1.default.createElement("div", { className: "flex items-center gap-2" },
                        react_1.default.createElement(button_1.Button, { onClick: () => navigate(manageLicensesPath) }, "My Licenses"),
                        react_1.default.createElement(RenderIf_1.default, { isTrue: Boolean(user) },
                            react_1.default.createElement(dropdown_menu_1.DropdownMenu, null,
                                react_1.default.createElement(dropdown_menu_1.DropdownMenuTrigger, { asChild: true },
                                    react_1.default.createElement(button_1.Button, { variant: "ghost", className: "flex items-center gap-2 px-2" },
                                        react_1.default.createElement(avatar_1.Avatar, { className: "w-8 h-8 rounded-lg" },
                                            react_1.default.createElement(avatar_1.AvatarImage, { src: user === null || user === void 0 ? void 0 : user.avatar, alt: user === null || user === void 0 ? void 0 : user.firstName }),
                                            react_1.default.createElement(avatar_1.AvatarFallback, { className: "rounded-lg" }, avatarFallback)),
                                        react_1.default.createElement(lucide_react_1.ChevronDown, { className: "w-4 h-4" }))),
                                react_1.default.createElement(dropdown_menu_1.DropdownMenuContent, { align: "end", className: "w-56" },
                                    secondaryItems.map((item, index) => (react_1.default.createElement(dropdown_menu_1.DropdownMenuItem, { key: `plain-layout-footer-item-${item.id}-${index}`, onClick: item.action },
                                        react_1.default.createElement("span", null, item.label)))),
                                    react_1.default.createElement(dropdown_menu_1.DropdownMenuItem, { onClick: viewProfile },
                                        react_1.default.createElement("span", null, "Account Profile")),
                                    react_1.default.createElement(dropdown_menu_1.DropdownMenuItem, { onClick: logoutAction },
                                        react_1.default.createElement("span", null, "Logout")))))))),
            react_1.default.createElement("div", { className: "p-4" },
                react_1.default.createElement("div", { className: "h-full space-y-4" },
                    react_1.default.createElement("div", { className: "flex shrink-0 items-center justify-between w-full transition-[width,height] ease-linear" },
                        react_1.default.createElement("div", { className: "flex items-center gap-4" },
                            react_1.default.createElement(RenderIf_1.default, { isTrue: canGoBack() },
                                react_1.default.createElement(button_1.Button, { variant: "outline", size: "icon", onClick: (event) => {
                                        event.preventDefault();
                                        if (currentRoute && currentRoute.backPath) {
                                            const backPath = currentRoute.backPath(authContext);
                                            navigate(backPath);
                                            return;
                                        }
                                        goBack();
                                    } },
                                    react_1.default.createElement(lucide_react_1.ChevronLeft, null))),
                            react_1.default.createElement("h1", { className: "text-xl font-medium tracking-tight lg:text-2xl" }, getTitle())),
                        react_1.default.createElement("div", { className: "flex items-center gap-2" }, mainActionsProvider.getMainActions(authContext, getCurrentPath()).map((next) => {
                            const variant = next.variant ? next.variant : 'default';
                            return (react_1.default.createElement(button_1.Button, { key: next.label, onClick: (event) => {
                                    event.preventDefault();
                                    next.action(authContext);
                                }, variant: variant },
                                next.icon,
                                " ",
                                next.label));
                        }))),
                    react_1.default.createElement("div", { className: "w-full" }, isRoot ? dashboardContentProvider.getHomeDashboard().getContent(authContext) : react_1.default.createElement(react_router_dom_1.Outlet, null)))),
            react_1.default.createElement(RenderIf_1.default, { isTrue: Boolean(isRoot) },
                react_1.default.createElement(exports.HomeFooter, null)))));
};
exports.SideBarAppLayout = SideBarAppLayout;
const DocsSideBarAppLayout = ({}) => {
    const location = (0, react_router_dom_1.useLocation)();
    const mainActionsProvider = (0, useMainActionProvider_1.default)();
    const { pathProvider, user, clearSession, logoutUrl, targetGroup, isSysAdmin } = (0, react_1.useContext)(useAuth_1.SessionContext);
    const { userId } = (0, react_router_dom_1.useParams)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const authContext = (0, react_1.useContext)(useAuth_1.SessionContext);
    const routeProvider = (0, user_routes_provider_1.default)();
    const isRoot = (0, react_1.useMemo)(() => location.pathname === '/', [location.pathname]);
    const goBack = useSmartBack();
    const { state } = (0, useSideBarContext_1.useSideBarContext)();
    const sidebarSecondaryItemProvider = (0, useSidebarSecondaryItemProvider_1.default)();
    const avatarFallback = (0, react_1.useMemo)(() => {
        if (user && user.firstName && user.lastName && user.firstName.length > 0 && user.lastName.length > 0) {
            return user.firstName.charAt(0) + user.lastName.charAt(0);
        }
        if (user && user.firstName && user.firstName.length >= 2) {
            return user.firstName.substring(0, 2);
        }
        return 'NA';
    }, [user]);
    const secondaryItems = (0, react_1.useMemo)(() => {
        if (!authContext || !sidebarSecondaryItemProvider) {
            return [];
        }
        return sidebarSecondaryItemProvider.getSecondaryItems(authContext);
    }, [sidebarSecondaryItemProvider, authContext]);
    const viewProfile = (0, react_1.useCallback)(() => {
        navigate('/user/profile');
    }, [navigate]);
    const canGoBack = (0, react_1.useCallback)(() => {
        if (!pathProvider) {
            return false;
        }
        const currentPath = pathProvider.getCurrentPath();
        const currentRoute = routeProvider.getRoute(currentPath);
        if (!currentRoute) {
            return false;
        }
        return currentRoute.canGoBack || false;
    }, [pathProvider, routeProvider, user, userId]);
    const getCurrentPath = (0, react_1.useCallback)(() => {
        if (!pathProvider) {
            return '';
        }
        return pathProvider.getCurrentPath();
    }, [pathProvider, routeProvider]);
    const currentRoute = (0, react_1.useMemo)(() => {
        if (!pathProvider) {
            return undefined;
        }
        const currentPath = pathProvider.getCurrentPath();
        if (!currentPath) {
            return undefined;
        }
        const currentRoute = routeProvider.getRoute(currentPath);
        if (!currentRoute) {
            return undefined;
        }
        return currentRoute;
    }, [pathProvider, routeProvider]);
    const manageLicensesPath = (0, react_1.useMemo)(() => {
        if (targetGroup && targetGroup.trim().length > 0) {
            return '/licenses/group';
        }
        return '/licenses/group';
    }, [targetGroup]);
    const logoutAction = (0, react_1.useCallback)(async () => {
        try {
            if (logoutUrl && typeof window !== 'undefined') {
                clearSession();
                window.location.href = logoutUrl;
            }
        }
        catch (error) {
            console.error(error);
        }
    }, [clearSession, logoutUrl]);
    return (react_1.default.createElement(sidebar_1.SidebarProvider, null,
        react_1.default.createElement(docs_sidebar_1.DocsSidebar, null),
        react_1.default.createElement(sidebar_1.SidebarInset, null,
            react_1.default.createElement(RenderIf_1.default, { isTrue: Boolean(isRoot || !isSysAdmin) },
                react_1.default.createElement(exports.HomeHeader, null)),
            react_1.default.createElement(RenderIf_1.default, { isTrue: Boolean(!isRoot) },
                react_1.default.createElement("header", { className: "bg-background/40 flex shrink-0 items-center justify-between px-4 transition-[width,height] h-[--header-height] md:peer-data-[state=collapsed]:h-[calc(var(--header-height)-4px)] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12 border-b border-border backdrop-blur-md sticky z-50 top-0 md:rounded-tl-xl md:rounded-tr-xl" },
                    react_1.default.createElement("div", { className: "flex items-center gap-2" },
                        react_1.default.createElement(RenderIf_1.default, { isTrue: state === 'expanded' },
                            react_1.default.createElement(docs_sidebar_1.HiddenSidebarTrigger, null))),
                    react_1.default.createElement("div", { className: "flex items-center gap-2" },
                        react_1.default.createElement(RenderIf_1.default, { isTrue: Boolean(user) },
                            react_1.default.createElement(button_1.Button, { onClick: () => navigate(manageLicensesPath) }, "My Licenses")),
                        react_1.default.createElement(RenderIf_1.default, { isTrue: Boolean(user) },
                            react_1.default.createElement(dropdown_menu_1.DropdownMenu, null,
                                react_1.default.createElement(dropdown_menu_1.DropdownMenuTrigger, { asChild: true },
                                    react_1.default.createElement(button_1.Button, { variant: "ghost", className: "flex items-center gap-2 px-2" },
                                        react_1.default.createElement(avatar_1.Avatar, { className: "w-8 h-8 rounded-lg" },
                                            react_1.default.createElement(avatar_1.AvatarImage, { src: user === null || user === void 0 ? void 0 : user.avatar, alt: user === null || user === void 0 ? void 0 : user.firstName }),
                                            react_1.default.createElement(avatar_1.AvatarFallback, { className: "rounded-lg" }, avatarFallback)),
                                        react_1.default.createElement(lucide_react_1.ChevronDown, { className: "w-4 h-4" }))),
                                react_1.default.createElement(dropdown_menu_1.DropdownMenuContent, { align: "end", className: "w-56" },
                                    secondaryItems.map((item, index) => (react_1.default.createElement(dropdown_menu_1.DropdownMenuItem, { key: `plain-layout-footer-item-${item.id}-${index}`, onClick: item.action },
                                        react_1.default.createElement("span", null, item.label)))),
                                    react_1.default.createElement(dropdown_menu_1.DropdownMenuItem, { onClick: viewProfile },
                                        react_1.default.createElement("span", null, "Account Profile")),
                                    react_1.default.createElement(dropdown_menu_1.DropdownMenuItem, { onClick: logoutAction },
                                        react_1.default.createElement("span", null, "Logout")))))))),
            react_1.default.createElement("div", { className: "p-4" },
                react_1.default.createElement("div", { className: "space-y-4" },
                    react_1.default.createElement("div", { className: "flex shrink-0 items-center justify-between w-full transition-[width,height] ease-linear" },
                        react_1.default.createElement("div", { className: "flex items-center gap-4" },
                            react_1.default.createElement(RenderIf_1.default, { isTrue: canGoBack() },
                                react_1.default.createElement(button_1.Button, { variant: "outline", size: "icon", onClick: (event) => {
                                        event.preventDefault();
                                        if (currentRoute && currentRoute.backPath) {
                                            const backPath = currentRoute.backPath(authContext);
                                            navigate(backPath);
                                            return;
                                        }
                                        goBack();
                                    } },
                                    react_1.default.createElement(lucide_react_1.ChevronLeft, null))),
                            react_1.default.createElement("h1", { className: "text-xl font-medium tracking-tight lg:text-2xl" })),
                        react_1.default.createElement("div", { className: "flex items-center gap-2" }, mainActionsProvider.getMainActions(authContext, getCurrentPath()).map((next) => {
                            const variant = next.variant ? next.variant : 'default';
                            return (react_1.default.createElement(button_1.Button, { key: next.label, onClick: (event) => {
                                    event.preventDefault();
                                    next.action(authContext);
                                }, variant: variant },
                                next.icon,
                                " ",
                                next.label));
                        }))),
                    react_1.default.createElement("div", { className: "w-full" },
                        react_1.default.createElement(react_router_dom_1.Outlet, null))),
                react_1.default.createElement("div", { className: 'pt-8' },
                    react_1.default.createElement(exports.DocsFooter, null))))));
};
exports.DocsSideBarAppLayout = DocsSideBarAppLayout;
const PlainLayout = ({}) => {
    const location = (0, react_router_dom_1.useLocation)();
    const dashboardContentProvider = (0, useDashboardContent_1.default)();
    const { user, targetGroup, isSysAdmin } = (0, react_1.useContext)(useAuth_1.SessionContext);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const authContext = (0, react_1.useContext)(useAuth_1.SessionContext);
    const routeProvider = (0, user_routes_provider_1.default)();
    const isRoot = (0, react_1.useMemo)(() => location.pathname === '/', [location.pathname]);
    const refreshTick = (0, store_1.useAppSelector)((state) => state.groupContext.refreshTick);
    const mainActionsProvider = (0, useMainActionProvider_1.default)();
    const goBack = useSmartBack();
    const { userId } = (0, react_router_dom_1.useParams)();
    const [isClient, setClient] = react_1.default.useState(false);
    const pathProvider = (0, react_1.useMemo)(() => ({
        getCurrentPath: () => {
            const flatRoutes = routeProvider.getFlatRoutes();
            const exactMatch = flatRoutes.find((route) => route.path === location.pathname);
            if (exactMatch) {
                return exactMatch.path;
            }
            const matchingRoute = flatRoutes
                .map((route) => route.path)
                .find((routePath) => (0, path_to_regexp_1.match)(routePath)(location.pathname));
            return matchingRoute !== null && matchingRoute !== void 0 ? matchingRoute : location.pathname;
        },
    }), [location.pathname, routeProvider]);
    const canGoBack = (0, react_1.useCallback)(() => {
        if (!pathProvider) {
            return false;
        }
        const currentPath = pathProvider.getCurrentPath();
        const currentRoute = routeProvider.getRoute(currentPath);
        if (!currentRoute) {
            return false;
        }
        return currentRoute.canGoBack || false;
    }, [pathProvider, routeProvider, user, userId]);
    const getCurrentPath = (0, react_1.useCallback)(() => {
        if (!pathProvider) {
            return '';
        }
        return pathProvider.getCurrentPath();
    }, [pathProvider, routeProvider]);
    const getTitle = (0, react_1.useCallback)(() => {
        if (isRoot || !isClient) {
            return '';
        }
        if (!pathProvider) {
            return DASHBOARD_TITLE;
        }
        const currentPath = pathProvider.getCurrentPath();
        const currentRoute = routeProvider.getRoute(currentPath);
        if (!currentRoute) {
            return DASHBOARD_TITLE;
        }
        if (currentRoute.nameProvider) {
            return currentRoute.nameProvider(authContext);
        }
        return currentRoute.name;
    }, [pathProvider, routeProvider, refreshTick, user, authContext, isRoot, isClient]);
    const currentRoute = (0, react_1.useMemo)(() => {
        if (!pathProvider) {
            return undefined;
        }
        const currentPath = pathProvider.getCurrentPath();
        if (!currentPath) {
            return undefined;
        }
        const currentRoute = routeProvider.getRoute(currentPath);
        if (!currentRoute) {
            return undefined;
        }
        return currentRoute;
    }, [pathProvider, routeProvider]);
    (0, react_1.useEffect)(() => {
        if (isSysAdmin && user && user.groups && user.groups.length > 0 && !targetGroup) {
            navigate('/group/selection');
        }
    }, [refreshTick, user, navigate, targetGroup, isSysAdmin]);
    (0, react_1.useEffect)(() => {
        if (!document) {
            return;
        }
        const yearEl = document.getElementById('year');
        if (!yearEl) {
            return;
        }
        yearEl.textContent = new Date().getFullYear().toString();
    }, []);
    (0, react_1.useEffect)(() => {
        setClient(true);
    }, []);
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(exports.HomeHeader, null),
        react_1.default.createElement(RenderIf_1.default, { isTrue: Boolean(!isRoot) },
            react_1.default.createElement("div", { className: "p-4" },
                react_1.default.createElement("div", { className: "h-full space-y-4" },
                    react_1.default.createElement("div", { className: "px-4 mx-auto max-w-7xl sm:px-6 lg:px-8" },
                        react_1.default.createElement("div", { className: "flex shrink-0 items-center justify-between w-full transition-[width,height] ease-linear" },
                            react_1.default.createElement("div", { className: "flex items-center gap-4" },
                                react_1.default.createElement(RenderIf_1.default, { isTrue: canGoBack() },
                                    react_1.default.createElement(button_1.Button, { variant: "outline", size: "icon", onClick: (event) => {
                                            event.preventDefault();
                                            if (currentRoute && currentRoute.backPath) {
                                                const backPath = currentRoute.backPath(authContext);
                                                navigate(backPath);
                                                return;
                                            }
                                            goBack();
                                        } },
                                        react_1.default.createElement(lucide_react_1.ChevronLeft, null))),
                                react_1.default.createElement("h1", { className: "text-xl font-medium tracking-tight lg:text-2xl" }, getTitle())),
                            react_1.default.createElement(RenderIf_1.default, { isTrue: Boolean(isClient) },
                                react_1.default.createElement("div", { className: "flex items-center gap-2" }, mainActionsProvider
                                    .getMainActions(authContext, getCurrentPath())
                                    .map((next) => {
                                    const variant = next.variant ? next.variant : 'default';
                                    return (react_1.default.createElement(button_1.Button, { key: next.label, onClick: (event) => {
                                            event.preventDefault();
                                            next.action(authContext);
                                        }, variant: variant },
                                        next.icon,
                                        " ",
                                        next.label));
                                })))))))),
        react_1.default.createElement("div", null,
            react_1.default.createElement(RenderIf_1.default, { isTrue: Boolean(isRoot) }, dashboardContentProvider.getHomeDashboard().getContent(authContext)),
            react_1.default.createElement(RenderIf_1.default, { isTrue: Boolean(!isRoot) },
                react_1.default.createElement("div", { className: "px-4 pb-16 mx-auto max-w-7xl sm:px-6 lg:px-8" },
                    react_1.default.createElement(react_router_dom_1.Outlet, null)))),
        react_1.default.createElement(exports.HomeFooter, null)));
};
exports.PlainLayout = PlainLayout;
const HomeComponent = ({ queryClient }) => {
    const { user, isSysAdmin, } = (0, react_1.useContext)(useAuth_1.SessionContext);
    const dispatch = (0, store_1.useAppDispatch)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const location = (0, react_router_dom_1.useLocation)();
    const resolvedQueryClient = queryClient !== null && queryClient !== void 0 ? queryClient : (0, query_client_1.getOrCreateQueryClient)();
    const groupContext = (0, useGroupContext_1.default)();
    const dehydrated = typeof window !== 'undefined' ? window.__PRERENDER_QUERY__ : undefined;
    const isDocs = (0, react_1.useMemo)(() => {
        return location.pathname.startsWith('/docs');
    }, [location.pathname]);
    const shouldUsePlain = (0, react_1.useMemo)(() => {
        if (!user) {
            return true;
        }
        return !isSysAdmin;
    }, [user, isSysAdmin]);
    (0, react_1.useEffect)(() => {
        groupContext.setShowSecondaryAction(false);
        groupContext.setShowGroupBillingDetails(false);
        groupContext.setShowSwitchOrganization(false);
        dispatch((0, group_slice_1.setRefreshTick)());
    }, [groupContext, dispatch]);
    (0, react_1.useEffect)(() => {
        const params = new URLSearchParams(window.location.search);
        const next = params.get('next');
        if (next && next.length > 0) {
            navigate(next);
        }
    }, [navigate]);
    if (isDocs) {
        return (react_1.default.createElement(react_query_1.QueryClientProvider, { client: resolvedQueryClient },
            react_1.default.createElement(useSideBarContext_1.SideBarContextProvider, null,
                react_1.default.createElement(react_query_1.Hydrate, { state: dehydrated },
                    react_1.default.createElement(exports.DocsSideBarAppLayout, null),
                    react_1.default.createElement(toaster_1.Toaster, null),
                    react_1.default.createElement(react_query_devtools_1.ReactQueryDevtools, { initialIsOpen: false })))));
    }
    if (shouldUsePlain) {
        return (react_1.default.createElement(react_query_1.QueryClientProvider, { client: resolvedQueryClient },
            react_1.default.createElement(react_query_1.Hydrate, { state: dehydrated },
                react_1.default.createElement(exports.PlainLayout, null),
                react_1.default.createElement(toaster_1.Toaster, null),
                react_1.default.createElement(react_query_devtools_1.ReactQueryDevtools, { initialIsOpen: false }))));
    }
    return (react_1.default.createElement(react_query_1.QueryClientProvider, { client: resolvedQueryClient },
        react_1.default.createElement(useSideBarContext_1.SideBarContextProvider, null,
            react_1.default.createElement(exports.SideBarAppLayout, null),
            react_1.default.createElement(toaster_1.Toaster, null),
            react_1.default.createElement(react_query_devtools_1.ReactQueryDevtools, { initialIsOpen: false }))));
};
exports.HomeComponent = HomeComponent;
